module.exports = __webpack_public_path__ + "static/media/wesley.198990be.jpg";